import Tables from 'src/class/Tables';
import i18n from 'src/i18n'

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
    },
    {
      prop: 'user_name',
      label: i18n.t('common_words.user'),
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
    },
    {
      prop: 'lot_name',
      label: i18n.t('common_words.allotment'),
    },
    {
      prop: 'date_save',
      label: i18n.t('common_words.save_date'),
    },
  ];

  const TableDetails = { ...Tables.Table };
  TableDetails.tableColumns = [
    {
      prop: 'code_detail',
      label: i18n.t('common_words.code_detailed'),
      minWidth: 150,
    },
    {
      prop: 'tower',
      label: i18n.t('common_words.tower_number'),
    },
    {
      prop: 'latitude',
      label: i18n.t('common_words.latitude'),
    },
    {
      prop: 'longitude',
      label: i18n.t('common_words.longitude'),
    },
  ];

  const TableUnits = { ...Tables.Table };
  TableUnits.tableColumns = [

    {
      prop: 'sample',
      label: i18n.t('common_words.sample'),
    },
    {
      prop: 'disease_status.disease_status',
      label: i18n.t('common_words.level_or_status'),
    },
    {
      prop: 'full_date',
      label: i18n.t('common_words.date'),
    },
  ];

  const searchs = {
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    pagedDataDetails() {
      return this.tableDataDetails.slice(this.fromDetails, this.toDetails);
    },

    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedDataDetails() {
      let result = this.tableDataDetails;
      if (this.searchQueryDetails !== '') {
        result = this.fuseSearchDetails.search(
          '=' + this.searchQueryDetails + ''
        );
      }
      this.paginationDetails.total = result.length;

      return result.slice(this.fromDetails, this.toDetails);
    },

    toDetails() {
      let highBound = this.fromDetails + this.paginationDetails.perPage;
      if (this.totalDetails < highBound) {
        highBound = this.totalDetails;
      }

      return highBound;
    },

    fromDetails() {
      return (
        this.paginationDetails.perPage *
        (this.paginationDetails.currentPage - 1)
      );
    },

    totalDetails() {
      // this.paginationDetails.total = this.tableDataDetails.length;
      return this.paginationDetails.total;
    },
    /* };
  
    const searchUnits = { */

    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedDataUnits() {
      let result = this.tableDataUnits;
      if (this.searchQueryUnits !== '') {
        result = this.fuseSearchUnits.search('=' + this.searchQueryUnits + '');
      }
      this.paginationUnits.total = result.length;

      return result.slice(this.fromUnits, this.toUnits);
    },

    totalUnits() {
      // this.paginationUnits.total = this.tableDataUnits.length;
      return this.paginationUnits.total
    },

    toUnits() {
      let highBound = this.fromUnits + this.paginationUnits.perPage;
      if (this.totalUnits < highBound) {
        highBound = this.totalUnits;
      }

      return highBound;
    },

    fromUnits() {
      return (
        this.paginationUnits.perPage *
        (this.paginationUnits.currentPage - 1)
      );
    },
  };

  return { Table, searchs, TableDetails, TableUnits };

};

export default configTable;
